import { RESET_TABLE_FILTER, UPDATE_TABLE_FILTER,UPDATE_SELECTED_COLUMNS } from '../actionTypes';

export const updateTable = (data) => {
	return {
		type: UPDATE_TABLE_FILTER,
		payload: {
			...data,
		},
	};
};

export const updateSelectedColumns = (listId, columnTitles) => ({
  type: UPDATE_SELECTED_COLUMNS,
  payload: {
    listId,
    columnTitles,
  },
});

export const resetFilterTable = () => {
	return {
		type: RESET_TABLE_FILTER,
	};
};
